import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ChildCompanyFilter from "./ChildCompanyFilter";
import companyDataType from "./types/companyDataType";
import { Title, MobileTitle, Subtitle } from "./styles/action-bar-styles";

const ActionBarTitle = (props) => {
  const {
    betaBadge,
    childCompanyFilterTitleSuffix,
    companyData,
    mobileTitle,
    setSelectedCompany,
    subtitle,
    title,
    showChildCompanyFilter,
  } = props;

  if (showChildCompanyFilter) {
    return (
      <ChildCompanyFilter
        selectedCompany={companyData.selectedCompany}
        currentCompany={companyData.currentCompany}
        selectableCompanies={companyData.selectableCompanies}
        setSelectedCompany={setSelectedCompany}
        titleSuffix={childCompanyFilterTitleSuffix}
      />
    );
  }

  return (
    <Fragment>
      {title && <Title betaBadge={betaBadge}>{title}</Title>}
      {mobileTitle && (
        <MobileTitle betaBadge={betaBadge}>{mobileTitle}</MobileTitle>
      )}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Fragment>
  );
};

ActionBarTitle.propTypes = {
  betaBadge: PropTypes.bool,
  childCompanyFilterTitleSuffix: PropTypes.string,
  companyData: companyDataType,
  mobileTitle: PropTypes.string,
  setSelectedCompany: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  showChildCompanyFilter: PropTypes.bool.isRequired,
};

ActionBarTitle.defaultProps = {
  betaBadge: PropTypes.isNull,
  childCompanyFilterTitleSuffix: "",
  companyData: {},
  mobileTitle: PropTypes.isNull,
  setSelectedCompany: () => {},
  subtitle: PropTypes.isNull,
  title: PropTypes.isNull,
};

export default ActionBarTitle;
